(function () {
  'use strict';

  angular.module('app').component('transportationContentList', transportationContentList());

  function transportationContentList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onTransportationContentShowed: '&',
        websiteId: '<',
        defaultLanguage: '<',
      },
      controller: TransportationContentListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-contents/transportation-content-list/transportation-content-list.component.html',
    };
  }

  TransportationContentListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'TransportationContentService',

    // Angular downgraded service
    'locationService',
  ];

  function TransportationContentListCtrl(
    config,
    UtilService,
    AbilityService,
    TransportationContentService,

    // Angular downgraded service
    locationService
  ) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_transportation_accountadmin'),
      canUpdate: AbilityService.can('update_transportation_accountadmin'),
      canDestroy: AbilityService.can('destroy_transportation_accountadmin'),
    };

    vm.featuredOptions = config.BOOLEAN_OPTIONS;
    vm.publishedOptions = config.BOOLEAN_OPTIONS;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TransportationContentService.getFilterCriteria();

    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems       = onUpdateItems;
    vm.changeItemFeatured = changeItemFeatured;
    vm.changeItemPublished = changeItemPublished;

    vm.searchLocations = (search, option) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      locationService.getLocations(params).subscribe((response) => {
        let locations = response;

        if (option === 'departure') {
          vm.departureLocations = locations;
        } else {
          vm.arrivalLocations = locations;
        }
      });
    };

    vm.clearLocations = (option) => {
      if (option === 'departure') {
        vm.departureLocations = [];
      } else {
        vm.arrivalLocations = [];
      }

      vm.UtilService.filterResult();
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      TransportationContentService.getTransportationsContents(vm.websiteId, vm.filterCriteria).then(
        function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.totalItems = vm.meta.totalItems;

          vm.loadingItems = false;

          vm.showActions = false;
          vm.selectedAll = false;
        }
      );
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.departureLocations = [];
      vm.arrivalLocations = [];

      vm.filterCriteria = TransportationContentService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onTransportationContentShowed({ item: item });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      TransportationContentService.deleteTransportationContent(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TransportationContentService.changeTransportationContentStatus(item);
    }

    /*function onUpdateItems(action) {
            let successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };
            
            TransportationContentService.updateTransportationsContents(action, vm.items, successCallback);
        }*/

    function changeItemFeatured(item) {
      TransportationContentService.changeTransportationContentFeatured(item);
    }

    function changeItemPublished(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TransportationContentService.changeTransportationContentPublished(item);
    }
  }
})();
